<template>
  <div class="chance-list">
    <tab></tab>
    <div class="row">
      <div class="activity-top" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <img :src="imgUrl" alt="#" class="inner-item-img"/>
        <div class="activity-top-font">
          <div class="top-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>

        <div class="activity-top-bottom spaceBetween">
          <!-- <div class="top-bottom-list" @click="goChance(item)" v-for="(item,index) in legList" :key="index"><a style="color:#fff;">{{lanType==1?item.title:item.titleEn}}</a></div> -->
          <!-- <div class="top-bottom-list"><a href="#gd1" style="color:#fff;">设立科学碳目标</a></div>
          <div class="top-bottom-list"><a href="#gd1" style="color:#fff;">行业指南</a></div>
          <div class="top-bottom-list"><a href="#gd1" style="color:#fff;">案例</a></div>
          <div class="top-bottom-list"><a href="#gd1" style="color:#fff;">活动</a></div> -->
        </div>
      </div>

      <div class="phone-activity-top hidden-md hidden-lg" v-if="isShowWeb">
        <img :src="imgUrl" alt="#" class="phone-inner-img"/>
        <div class="activity-top-font">
          <div class="phone-font-font">{{lanType==1?pageInfo.title:pageInfo.titleEn}}</div>
        </div>
      </div>
    </div>

    <div class="row" id="gd1">
      <div class="carbon-neck spaceBetween" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="carbon-neck-left">
          <div class="neck-left-title">{{lanType==1?initiative.title:initiative.titleEn}}</div>
          <div class="neck-left-font" v-html="lanType==1?initiative.content:initiative.contentEn"></div>
          <!-- <div class="neck-left-font">倡议提供工具、最佳实践指导和针对不同行业的特定资源，帮助企业自主设定符合联合国政府间气候变化专门委员会第五次评估报告中远低于1.5℃的脱碳水平的、基于科学的减排目标。</div>
          <div class="neck-left-font">随着全球加速转向低碳经济，每个国家的每个行业都将经历低碳转型的过程，而全球绝大多数的温室气体排放都直接或间接地受到企业的影响。有远见的企业已经洞察了转型的机遇，同时也意识到了其紧迫性。企业设定科学碳目标不仅仅为将全球平均温升控制在1.5℃以内做出了贡献，同时也将为企业及其价值链带来积极影响。</div>
          <div class="neck-left-font">截至2020年10月，与科学碳目标倡议合作 的企业数量已经超过1000家，他们分布在全球60个国家的近50个行业，总市值超过15.4万亿美元（囊括了五分之一的全球财富500强企业）。在已经设定了具有雄心的科学碳目标的企业名单中，活跃着各领域知名品牌和领军企业的身影，他们正在以必要的步伐和规模减少排放量。</div>
          <div class="neck-left-font">项目的技术专家将独立评估并批准企业计划设立的目标，从而增强该目标的公信力。项目的宣传团队将确保企业在展示自身具有前瞻性的减排计划和低碳领导力之后，能够获得应有的认可。自2021年起，WWF将联合OPF启动科学碳目标训练营。训练营面向有志于设定科学减排目标或希望了解科学碳目标倡议的企业及其价值链。训练营拟每半年开营一次，每次为期1-2天，介绍包括应对气候变化政策、科学碳目标倡议参与流程及规则、碳目标设定行业指南、科学碳目标设定案例分析等内容，以帮助企业了解应对气候变化议题并熟悉和掌握目标设定相应工具。</div> -->
        </div>
        <!-- <div class="carbon-neck-right">
          <img src="@/images/carbonIcon.png" alt="#" class="neck-right-img"/>
        </div> -->
      </div>

      <div class="phone-neck-all hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phone-carbon-neck">
          <div class="carbon-neck-title">{{lanType==1?initiative.title:initiative.titleEn}}</div>
          <!-- <img src="@/images/carbonIcon.png" alt="#" class="carbon-neck-img"/> -->
          <div class="carbon-neck-font" v-html="lanType==1?initiative.content:initiative.contentEn"></div>
          <!-- <div class="carbon-neck-font">倡议提供工具、最佳实践指导和针对不同行业的特定资源，帮助企业自主设定符合联合国政府间气候变化专门委员会第五次评估报告中远低于1.5℃的脱碳水平的、基于科学的减排目标。</div>
          <div class="carbon-neck-font">随着全球加速转向低碳经济，每个国家的每个行业都将经历低碳转型的过程，而全球绝大多数的温室气体排放都直接或间接地受到企业的影响。有远见的企业已经洞察了转型的机遇，同时也意识到了其紧迫性。企业设定科学碳目标不仅仅为将全球平均温升控制在1.5℃以内做出了贡献，同时也将为企业及其价值链带来积极影响。</div>
          <div class="carbon-neck-font">截至2020年10月，与科学碳目标倡议合作 的企业数量已经超过1000家，他们分布在全球60个国家的近50个行业，总市值超过15.4万亿美元（囊括了五分之一的全球财富500强企业）。在已经设定了具有雄心的科学碳目标的企业名单中，活跃着各领域知名品牌和领军企业的身影，他们正在以必要的步伐和规模减少排放量。</div>
          <div class="carbon-neck-font">项目的技术专家将独立评估并批准企业计划设立的目标，从而增强该目标的公信力。项目的宣传团队将确保企业在展示自身具有前瞻性的减排计划和低碳领导力之后，能够获得应有的认可。自2021年起，WWF将联合OPF启动科学碳目标训练营。训练营面向有志于设定科学减排目标或希望了解科学碳目标倡议的企业及其价值链。训练营拟每半年开营一次，每次为期1-2天，介绍包括应对气候变化政策、科学碳目标倡议参与流程及规则、碳目标设定行业指南、科学碳目标设定案例分析等内容，以帮助企业了解应对气候变化议题并熟悉和掌握目标设定相应工具。</div> -->
        </div>
      </div>
    </div>

    <!-- <div class="row" id="gd2">
      <div class="carbon-chest" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="carbon-chest-title">{{lanType==1?'设立科学碳目标':'Setting SBTi'}}</div>
        <div class="carbon-chest-center spaceBetween">
          <div class="chest-center-list columnCenter">
            <img src="@/images/label1.png" alt="#" class="center-list-img"/>
            <div class="center-list-bottom">
              <div class="list-bottom-title">{{lanType==1?'承诺':'Promise'}}</div>
              <div class="list-bottom-font">{{lanType==1?'递交承诺函，以明确企业设定科学目标的意图。':'Submit a letter to commit to setting a science-based target'}}</div>
            </div>
          </div>

          <div class="chest-center-list columnCenter">
            <img src="@/images/label2.png" alt="#" class="center-list-img"/>
            <div class="center-list-bottom">
              <div class="list-bottom-title">{{lanType==1?'开发':'Development'}}</div>
              <div class="list-bottom-font">{{lanType==1?'按照科学碳目标倡议认可的标准指定减排目标':'Develop your target(s) in line with ourscience-based criteria.'}}</div>
            </div>
          </div>

          <div class="chest-center-list columnCenter">
            <img src="@/images/label3.png" alt="#" class="center-list-img"/>
            <div class="center-list-bottom">
              <div class="list-bottom-title">{{lanType==1?'提交':'Submit'}}</div>
              <div class="list-bottom-font">{{lanType==1?'将企业制定的目标提交给科学碳目标倡议进行官方验证':'Submit the target for verification'}}</div>
            </div>
          </div>

          <div class="chest-center-list columnCenter">
            <img src="@/images/label4.png" alt="#" class="center-list-img"/>
            <div class="center-list-bottom">
              <div class="list-bottom-title">{{lanType==1?'沟通':'Communicate'}}</div>
              <div class="list-bottom-font">{{lanType==1?'通过验证后，企业可宣布目标并通知利益相关者':'Announce goals'}}</div>
            </div>
          </div>

          <div class="chest-center-list columnCenter">
            <img src="@/images/label5.png" alt="#" class="center-list-img"/>
            <div class="center-list-bottom">
              <div class="list-bottom-title">{{lanType==1?'披露':'Disclosure'}}</div>
              <div class="list-bottom-font">{{lanType==1?'企业报告排放数据并每年跟踪目标进度':'Disclosure progress'}}</div>
            </div>
          </div>
        </div>
        <div class="carbon-chest-label">{{lanType==1?'详细了解每一步的流程并开始您的科学碳目标设立之旅':'Learn more about the process of each step and start your journey of setting scientific carbon goals'}}</div>
        <div class="carbon-chest-bottom middle">
          <div class="chest-bottom-btn" @click="goChanceList">{{lanType==1?'立即开始':'Get Started'}}</div>
        </div>
      </div>

      <div class="phone-carbon-chest hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phoneCarbon-chest-title">{{lanType==1?'设立科学碳目标':'Setting SBTi'}}</div>
        <div class="phoneCarbon-chest-center spaceBetween">
          <div class="phoneChest-center-list columnCenter">
            <img src="@/images/label1.png" alt="#" class="phoneCenter-list-img"/>
            <div class="phoneCenter-list-bottom">
              <div class="phoneList-bottom-title">{{lanType==1?'承诺':'Promise'}}</div>
              <div class="phoneList-bottom-font">{{lanType==1?'递交承诺函，以明确企业设定科学目标的意图。':'Submit a letter to commit to setting a science-based target'}}</div>
            </div>
          </div>

          <div class="phoneChest-center-list columnCenter">
            <img src="@/images/label2.png" alt="#" class="phoneCenter-list-img"/>
            <div class="phoneCenter-list-bottom">
              <div class="phoneList-bottom-title">{{lanType==1?'开发':'Development'}}</div>
              <div class="phoneList-bottom-font">{{lanType==1?'按照科学碳目标倡议认可的标准指定减排目标':'Develop your target(s) in line with ourscience-based criteria.'}}</div>
            </div>
          </div>

          <div class="phoneChest-center-list columnCenter">
            <img src="@/images/label3.png" alt="#" class="phoneCenter-list-img"/>
            <div class="phoneCenter-list-bottom">
              <div class="phoneList-bottom-title">{{lanType==1?'提交':'Submit'}}</div>
              <div class="phoneList-bottom-font">{{lanType==1?'将企业制定的目标提交给科学碳目标倡议进行官方验证':'Submit the target for verification'}}</div>
            </div>
          </div>

          <div class="phoneChest-center-list columnCenter">
            <img src="@/images/label4.png" alt="#" class="phoneCenter-list-img"/>
            <div class="phoneCenter-list-bottom">
              <div class="phoneList-bottom-title">{{lanType==1?'沟通':'Communicate'}}</div>
              <div class="phoneList-bottom-font">{{lanType==1?'通过验证后，企业可宣布目标并通知利益相关者':'Announce goals'}}</div>
            </div>
          </div>

          <div class="phoneChest-center-list columnCenter">
            <img src="@/images/label5.png" alt="#" class="phoneCenter-list-img"/>
            <div class="phoneCenter-list-bottom">
              <div class="phoneList-bottom-title">{{lanType==1?'披露':'Disclosure'}}</div>
              <div class="phoneList-bottom-font">{{lanType==1?'企业报告排放数据并每年跟踪目标进度':'Disclosure progress'}}</div>
            </div>
          </div>
        </div>
        <div class="phoneCarbon-chest-label">{{lanType==1?'详细了解每一步的流程并开始您的科学碳目标设立之旅':'Learn more about the process of each step and start your journey of setting scientific carbon goals'}}</div>
        <div class="phoneCarbon-chest-bottom middle">
          <div class="phoneChest-bottom-btn" @click="goChanceList">{{lanType==1?'立即开始':'Get Started'}}</div>
        </div>
      </div>
    </div> -->

    <!-- <div class="row" id="gd3">
      <div class="carbon-abdomen" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="carbon-chest-title">{{lanType==1?'行业指南':'Industry Guide'}}</div>
        <div class="carbon-abdomen-center">
          <div class="abdomen-center-top spaceBetween" style="display:none;">
            <div class="center-top-list">Sector</div>
            <div class="center-top-list"></div>
          </div>
          <div class="abdomen-center-list spaceBetween" v-for="(item,index) in legList" :key="index" v-if="item.id!=19">
            <div class="center-list-left">
              <div class="list-left-font start">{{lanType==1?item.title:item.titleEn}}</div>
            </div>
            <div class="center-list-right spaceBetween">
              <div class="list-right-left start" style="visibility: hidden;">
                <img src="@/images/img1.svg" alt="#" class="right-left-img"/>
                <div class="right-left-font">Finalized</div>
              </div>
              <div class="list-right-right end">
                <div class="right-right-bnt" @click="goChance(item)">{{lanType==1?'查看更多':'VIEW MORE'}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="phone-carbon-abdomen hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phoneCarbon-chest-title">{{lanType==1?'行业指南':'Industry Guide'}}</div>
        <div class="phoneCarbon-abdomen-center">
          <div class="phoneAbdomen-center-top spaceBetween" style="display:none;">
            <div class="phoneCenter-top-list">Sector</div>
            <div class="phoneCenter-top-list"></div>
          </div>
          <div class="phoneAbdomen-center-list spaceBetween" v-for="(item,index) in legList" :key="index" v-if="item.id!=19">
            <div class="phoneCenter-list-left">
              <div class="phoneList-left-font start">{{lanType==1?item.title:item.titleEn}}</div>
            </div>
            <div class="phoneCenter-list-right spaceBetween">
              <div class="phoneList-right-left start" style="visibility: hidden;">
                <img src="@/images/img1.svg" alt="#" class="phoneRight-left-img"/>
                <div class="phoneRight-left-font">Finalized</div>
              </div>
              <div class="phoneList-right-right end">
                <div class="phoneRight-right-bnt" @click="goChance(item)">{{lanType==1?'查看更多':'VIEW MORE'}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div> -->

    <!-- <div class="row" id="gd4">
      <div class="carbon-leg" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="carbon-leg-center" >
          <div class="leg-center-left">
            <div class="neck-left-title">{{lanType==1?'案例':'Case'}}</div>
            <div class="center-left-middle">
              <div class="left-middle-title">{{lanType==1 ? pageList && pageList.length > 0 ? pageList[0].title : '' : pageList.titleEn}}</div>
              <div class="left-middle-font" v-html="lanType==1? pageList && pageList.length > 0 ?  pageList[0].brief : '':pageList[0].brief"></div>
              <div class="left-middle-bottom start" @click="goMechanism(pageList[0])">
                <div class="chest-bottom-btn">{{lanType==1?'了解更多':'Learn More'}}</div>
              </div>
            </div>
          </div>
          <img :src="pageList && pageList.length > 0 ? pageList[0].picStr : ''" alt="#" class="leg-center-right">
        </div>
      </div>

      <div class="phone-carbon-leg hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phoneCarbon-chest-title">{{lanType==1?'案例':'Case'}}</div>
        <div class="phoneCarbon-leg-center">
          <img :src="pageList && pageList.length > 0 ? pageList[0].picStr : ''" alt="#" class="leg-center-img"/>
          <div class="leg-center-bottom">
            <div class="center-bottom-title">{{lanType==1 ? pageList && pageList.length > 0 ? pageList[0].title : '' : pageList.titleEn}}</div>
            <div class="center-bottom-font" v-html="lanType==1 ? pageList && pageList.length > 0 ? pageList[0].brief : '':pageList[0].brief"></div>
            <div class="center-bottom-footer middle" @click="goMechanism(pageList[0])">
              <div class="phoneChest-bottom-btn">{{lanType==1?'了解更多':'Learn More'}}</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="row" id="gd4" v-if="pageList.length">
        <div class="web-row row" :class="{ 'hidden-xs hidden-sm': isShowWeb }">
            <!-- <div class="carbon-chest-title">{{lanType==1?'案例':'Case'}}</div> -->
            <!--  pc端  -->
            <div class="dynamic-center-list">
                <div class="center-list-top spaceBetween">
                    <div class="list-top-left start">
                        <div class="top-left-label bg1"></div>
                        <span>{{lanType==1?'案例':'Case'}}</span>
                    </div>

                    <div class="list-top-right end">
                        <div class="top-right-btn middle bg1" @click="goDynamicList(1)" v-if="count > 4">
                            <span class="right-btn-font">{{lanType==1? '查看更多' : 'See more'}}</span>
                            <img src="@/images/rights.png" alt="#" class="right-btn-icon">
                        </div>
                    </div>
                </div>

                <div class="center-list-center spaceBetween wrap">
                    <div class="list-center-li spaceBetween" @click="goMechanism(item)" v-for="(item,index) in pageList" :key="index">
                        <div class="center-li-left">
                            <img :src='item.picStr' alt="#" class="center-li-img">
                            <div class="li-left-btns start wrap">
                                <div class="left-btns-btn bg1" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                                <div class="left-btns-btn bg2" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                            </div>
                        </div>
                        <div class="center-li-right columnBetween">
                            <div class="li-right-title">{{lanType==1?item.title:item.titleEn}}</div>

                            

                            <div class="li-right-bottom spaceBetween">
                                <div class="right-bottom-time">{{item.release_date}}</div>
                                <div class="right-bottom-tips color1">{{lanType==1?'查看详情':'View details'}}</div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="phone-row row hidden-md hidden-lg" v-if="isShowWeb">
          <div class="phoneCarbon-chest-title">{{lanType==1?'案例':'Case'}}</div>
            <!--  web端  -->
            <div class="phone-center-list">
                <!-- <div class="center-list-top">{{lanType==1?'SBTi科学碳目标':'Science Based Target initiative (SBTi)'}}</div> -->

                <div class="phoneCarbon-leg-center" @click="goMechanism(item)" v-for="(item,index) in pageList" :key="index">
                    <div class="leg-center-top">
                        <img :src='item.picStr' alt="#" class="leg-center-img" />
                        <div class="info-list-layer">
                            <div class="list-layer-li bg1" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                            <div class="list-layer-li bg2" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                        </div>
                    </div>
                    <div class="leg-center-bottom">
                        <div class="center-bottom-title">{{lanType==1?item.title:item.titleEn}}</div>
                        <div class="center-bottom-bottom spaceBetween">
                            <div class="bottom-bottom-left">{{item.release_date}}</div>
                            <div class="bottom-bottom-right color1">{{lanType==1?'查看详情':'View details'}}</div>
                        </div>
                    </div>
                </div>

                <div class="center-list-bottom middle"  v-if="count > 4">
                    <div class="list-bottom-btn middle bg1" @click="goDynamicList(1)">{{lanType==1 ? '查看更多' : 'See more'}}</div>
                </div>
            </div>
        </div>
    </div>



    <!-- <div class="row" id="gd5">
      <div class="carbon-leg" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="carbon-chest-title">活动</div>

        <div class="index-foot-list spaceBetween" v-for="(item,index) in campaignList" :key="index" @click="goActivityDetail(item)">
          <div class="foot-list-left start">
            <div class="list-left-tips">{{lanType==1?item.addressStr:item.addressStrEn}}</div>
            <div class="list-left-radiu border1 columnCenter">
              <div class="left-radiu-tips color1">{{lanType==1?item.startTimeMoth:item.startTimeMothEn}}</div>
              <div class="left-radiu-center color1">{{lanType==1?item.startTimeDay:item.startTimeDayEn}}</div>
            </div>
            <div class="list-left-right">
              <div class="left-right-title">{{lanType==1?item.title:item.titleEn}}</div>
              <div class="left-right-bottom start">
                <div class="right-bottom-list start">
                  <img src="@/images/icon1.png" alt="#" class="bottom-list-img"/>
                  <div class="bottom-list-font" v-if="item.address">{{lanType==1?item.address:item.addressEn}}</div>
                  <div class="bottom-list-font" v-else>{{lanType==1?'线上会议':'Online conference'}}</div>
                </div>
                <div class="right-bottom-list start">
                  <img src="@/images/icon2.png" alt="#" class="bottom-list-img"/>
                  <div class="bottom-list-font">{{item.start_time}} —— {{item.end_time}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="foot-list-right">{{lanType==1?'查看详情':'View details'}}</div>
        </div>

        <div class="carbon-chest-bottom middle">
          <div class="chest-bottom-btn" @click="goActivity">{{lanType==1?'了解更多':'Learn More'}}</div>
        </div>
      </div>

      <div class="phone-carbon-leg hidden-md hidden-lg" v-if="isShowWeb">
        <div class="carbon-neck-title">活动</div>

        <div class="phone-foot-list spaceBetween" v-for="(item,index) in campaignList" :key="index" @click="goActivityDetail(item)">
          <div class="phone-list-left start">
            <div class="phone-left-tips">{{lanType==1?item.addressStr:item.addressStrEn}}</div>
            <div class="phone-left-radiu border1 columnCenter">
              <div class="phone-radiu-tips color1">{{lanType==1?item.startTimeMoth:item.startTimeMothEn}}</div>
              <div class="phone-radiu-center color1">{{lanType==1?item.startTimeDay:item.startTimeDayEn}}</div>
            </div>
            <div class="phone-left-right">
              <div class="phone-right-title">{{lanType==1?item.title:item.titleEn}}</div>
              <div class="phone-right-bottom start">
                <div class="phone-bottom-list start">
                  <img src="@/images/icon1.png" alt="#" class="phone-list-img"/>
                  <div class="phone-list-font" v-if="item.address">{{lanType==1?item.address:item.addressEn}}</div>
                  <div class="phone-list-font" v-else>{{lanType==1?'线上会议':'Online conference'}}</div>
                </div>
                <div class="phone-bottom-list start" style="margin-right:0;">
                  <img src="@/images/icon2.png" alt="#" class="phone-list-img"/>
                  <div class="phone-list-font">{{item.start_time}} —— {{item.end_time}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="center-bottom-footer middle">
          <div class="phoneChest-bottom-btn" @click="goActivity">{{lanType==1?'了解更多':'Learn More'}}</div>
        </div>
      </div>
    </div> -->
    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab'
import footerBar from '@/components/footerBar'
import axios from 'axios'
import { chunkArr,format } from '@/utils/util'
import config from '@/utils/config';
export default {
  name: 'chanceList',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      isShowWeb:config.urlList.isShowWeb,
      type:null,
      lanType:1,
      initiative:{},
      project:{},
      campaignList:[],
      legList:[],
      pageList:[],
      imgUrl: '',
      count: 0,
      pageInfo: {}
    }
  },
  methods:{
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    queryProject(id){
      const vm=this
      let obj = {
        id:id,
        token:localStorage.getItem("Cbhtoken")
      }
      axios.post(
      `${config.urlList.queryUrl}/api/cbh/project`,obj
      ).then(res => {
        if(res.data.code==1){
          if(id == 1){
            vm.imgUrl = res.data.data.picStr=`${config.urlList.imgUrl}${res.data.data.pic}`;
            vm.pageInfo = res.data.data
          }
          
          if(id==5){
            vm.initiative = res.data.data
          }else if(id==7){
            vm.project = res.data.data
          }
        }else{
          vm.$toast({
            text: '请登录后再试！',
            type: 'danger',
            duration: 1600
          })
          //vm.$router.push({ path:'/'  })
        }
      })
    },
    goChanceList(){
      const vm=this
      vm.$router.push({ path:'/chanceList',query:{}})
    },
    queryCampaignList(){
      const vm=this
      axios.post(`${config.urlList.queryUrl}/api/cbh/campaign_list`,{
        state:1,
        is_recommend:1,
        per_page:9,
      }).then(res => {
        if(res.data.code==1){
          res.data.data.data.forEach(da=>{
            da.titleEn = da.titleEn?da.titleEn:da.title
            da.addressEn = da.addressEn?da.addressEn:da.address
            da.picStr=`${config.urlList.imgUrl}${da.pic}`;
            da.addressStr=format(new Date(da.start_date),' YYYY年');
            da.addressStrEn=format(new Date(da.start_date),' YYYY/');
            da.startTimeMoth=format(new Date(da.start_date),' MM月')
            da.startTimeMothEn=format(new Date(da.start_date),' MM/')
            da.startTimeDay=format(new Date(da.start_date),' DD日')
            da.startTimeDayEn=format(new Date(da.start_date),' DD')
          })
          vm.campaignList=res.data.data.data
        }
      })
    },
    goActivity(){
      const vm=this
      vm.$router.push({ path:'/activity'  })
    },
    goChance(item){
      const vm=this
      // vm.$router.push({ path:'/projectDetail',query:{id:item.id}  })
      if(item.attachment){
        window.open(item.attachment, '_blank')
      }else{
        alert('暂无可跳转地址')
      }
    },
    queryProjectList2(index){
      const vm=this
      let arr=vm.projectList
      axios.get(`${config.urlList.queryUrl}/api/cbh/project_list/6`).then(res => {
        if(res.data.code==1){
          res.data.data.forEach(da=>{
            da.picStr = `${config.urlList.imgUrl}${da.pic}`
          })
          vm.legList = res.data.data
        }
      })
    },
    goMechanism(item){
      const vm=this
      vm.$router.push({ path:'/mechanism',query:{id:item.id,type:1}})
    },
    queryCampaign(){
      const vm=this
      axios.post(
        `${config.urlList.queryUrl}/api/cbh/news_list`,
        {
          type:3,
          is_recommend:0,
          project_id:1,
          page:1,
          per_page:4
        },
      ).then(res => {
        if(res.data.code==1){
          let arr=[];
          res.data.data.data.forEach(da=>{
            da.title_subEn = da.title_subEn?da.title_subEn:da.title_sub
            da.title_supEn = da.title_supEn?da.title_supEn:da.title_sup
            da.titleEn = da.titleEn?da.titleEn:da.title
            da.briefEn = da.briefEn?da.briefEn:da.brief
            da.picStr=`${config.urlList.imgUrl}${da.pic}`;
            da.updated_at=format(new Date(da.updated_at),'YYYY-MM-DD')
          })
          vm.pageList = res.data.data.data
          vm.count = res.data.data.total
        }else{
          vm.pageList=[]
        }
      })
    },
    goDynamicList(type){
      const vm=this
        vm.$router.push({ path:'/cases',query:{type}})
    }
  },
  created () {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted(){
    const vm=this
    vm.queryProject(1)
    vm.queryProject(5)
    vm.queryProject(7)
    vm.queryCampaignList()
    vm.queryProjectList2()
    vm.queryCampaign()
  }
}
</script>

<style scoped>

/**  pc banner图  **/
.activity-top{
  width: 100%;
  height: 4.0625rem;
  position: relative;
}
.inner-item-img{
  width: 100%;
  height: 100%;
}
.activity-top-font{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.top-font-font{
  font-size: 0.45rem;
  color: #fff;
  font-family: 'wwf';
}
.activity-top-bottom{
  width: 7.5rem;
  height: auto;
  position: absolute;
  bottom: 0.375rem;
  left: 50%;
  transform: translateX(-50%);
}
.top-bottom-list{
  font-size: 0.18rem;
  color: #fff;
  font-family: 'wwf';
  letter-spacing: 2px;
  position: relative;
  cursor: pointer;
}
.top-bottom-list::before{
  content: "";
  display: block;
  position: absolute;
  bottom: -20px;
  left: 0;
  right: 0;
  height: 3px;
  background: #fff;
}
/**  web Banner图  **/
.phone-activity-top{
  width: 100%;
  height: 8rem;
  position: relative;
}
.phone-inner-img{
  width: 100%;
  height: 100%;
}
.phone-font-font{
  font-size: 0.8rem;
  color: #fff;
}

/**  web 简介  web  **/
.carbon-neck{
  padding: 0.5rem 2rem;
  height: auto;
  align-items: flex-start;
}
.carbon-neck-left{
  flex: 2;
  height: auto;
}
.neck-left-title{
  font-size: 0.24rem;
  color: #333333;
  /* font-weight: 600; */
  text-align: left;
  margin-bottom: 0.1625rem;
  font-family: 'wwf';
}
.neck-left-font{
  font-size: 0.1125rem;
  line-height: 1.6;
  margin-bottom: 0.2rem;
  text-align: left;
}
.carbon-neck-right{
  margin-left: 0.45rem;
}
.neck-right-img{
  width: 100%;
}

/**  phone 简介  **/
.phone-neck-all{
  width: 100%;
  height: auto;
}
.phone-carbon-neck{
  padding: 0.32rem 0.5rem;
  height: auto;
}
.carbon-neck-title{
  font-size: 0.52rem;
  color: #000;
  font-weight: 600;
  margin-bottom: 0.32rem;
}
.carbon-neck-img{
  width: 100%;
  height: auto;
  margin-bottom: 0.24rem;
}
.carbon-neck-font{
  font-size: 0.32rem;
  color: #000;
  line-height: 1.4;
  margin-bottom: 0.24rem;
  text-align: left;
}

/**  web 设置科学碳目标  **/
.carbon-chest{
  padding: 0.32rem 0.5rem;
  height: auto;
  background: #f4f4f4;
}
.carbon-chest-title{
  font-size: 0.24rem;
  font-family: wwf;
  color: #333333;
  /* font-weight: 600; */
  text-align: center;
  margin-bottom: 0.1625rem;
}
.carbon-chest-center{
  width: 100%;
  height: auto;
  margin-bottom: 0.3125rem;
}
.chest-center-list{
  flex: 2;
  height: auto;
}
.center-list-img{
  width: 1.2125rem;
  height: auto;
  margin-bottom: 0.1rem;
}
.center-list-bottom{
  width: 1.2125rem;
  height: auto;
}
.list-bottom-title{
  font-size: 0.125rem;
  color: #333333;
  font-weight: 500;
  line-height: 1.6;
}
.list-bottom-font{
  font-size: 0.1rem;
  color: #333333;
}
.carbon-chest-label{
  font-size: 0.125rem;
  color: #333;
  font-weight: 500;
  line-height: 1.6;
}
.carbon-chest-bottom{
  width: 100%;
  height: auto;
  margin-top: 0.1875rem;
}
.chest-bottom-btn{
  width: 1.1875rem;
  height: 0.3125rem;
  text-align: center;
  line-height: 0.3125rem;
  background: #603773;
  font-size: 0.15rem;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
}

/**  phone 设置科学碳目标  **/
.phone-carbon-chest{
  padding: 0.48rem 0.5rem;
  height: auto;
  background: #f4f4f4;
}
.phoneCarbon-chest-title{
  font-size: 0.42rem;
  color: #333333;
  font-weight: 600;
  text-align: center;
  margin-bottom: 0.25rem;
}
.phoneCarbon-chest-center{
  width: 100%;
  height: auto;
  overflow-x: auto;
  margin-top: 0.5rem;
}
.phoneChest-center-list{
  margin: 0 0.25rem;
}
.phoneChest-center-list,.phoneCenter-list-img,.phoneCenter-list-bottom{
  width: 3.6rem;
  height: auto;
}
.phoneList-bottom-title{
  font-size: 0.21rem;
  color: #333;
  font-weight: 500;
  line-height: 1.6;
  margin-top: 0.21rem;
}
.phoneList-bottom-font{
  font-size: 0.187rem;
  color: #333;
  text-align: center;
  line-height: 1.4;
}
.phoneCarbon-chest-label{
  width: 100%;
  height: auto;
  margin-top: 0.42rem;
  text-align: center;
  font-size: 0.32rem;
  color: #333;
  font-weight: 500;
}
.phoneCarbon-chest-bottom{
  width: 100%;
  height: auto;
  margin-top: 0.64rem;
}
.phoneChest-bottom-btn{
  width: 2.5rem;
  height: 0.67rem;
  text-align: center;
  line-height: 0.67rem;
  background: #603773;
  font-size: 0.32rem;
  color: #fff;
  font-weight: 600;
}

/**  web  行业指南  **/
.carbon-abdomen{
  padding: 0.375rem 0.5rem;
  height: auto;
}
.carbon-abdomen-center{
  width: 6.55rem;
  height: auto;
  margin: 0.2875rem auto 0;
}
.center-top-list{
  font-size: 0.125rem;
  color: #000;
  font-weight: 600;
  text-align: left;
  flex: 2;
  height: auto;
  line-height: 1.4;
}
.abdomen-center-list{
  width: 100%;
  height: auto;
  margin-top: 0.1125rem;
  background: #ebebf4;
  border-radius: 2px;
}
.list-left-font{
  padding: 0.12rem 0.1rem;
  font-size: 0.1rem;
  color: #333;
  line-height: 1.2;
}
.list-right-left,.center-list-right,.center-list-left{
  flex: 2;
  height: auto;
}
.right-left-img{
  width: 0.15rem;
  height: auto;
  margin-left: 0.08rem;
}
.right-left-font{
  font-size: 0.1rem;
  color: #333;
  line-height: 1.2;
  margin-left: 0.1rem;
}
.right-right-bnt{
  width: 0.8625rem;
  height: 0.25rem;
  background: #603773;
  text-align: center;
  line-height: 0.25rem;
  font-size: 0.1rem;
  color: #fff;
  font-weight: 500;
  margin-right: 0.125rem;
  border-radius: 0.25rem;
  cursor: pointer;
}

/**  phone  行业指南  **/
.phone-carbon-abdomen{
  padding: 0.48rem 0.5rem;
  height: auto;
}
.phoneCarbon-abdomen-center{
  width: 100%;
  height: auto;
  margin-top: 0.32rem;
}
.phoneCenter-top-list{
  flex: 2;
  height: auto;
  font-size: 0.24rem;
  color: #333;
  font-weight: 600;
  text-align: left;
}
.phoneAbdomen-center-list{
  width: 100%;
  height: auto;
  margin-top: 0.2rem;
  background: #ebebf4;
  border-radius: 2px;
  min-height: 1.2rem;
}
.phoneCenter-list-left,.phoneCenter-list-right{
  flex: 2;
  height: auto;
}
.phoneList-left-font{
  padding: 0.24rem 0.2rem;
  font-size: 0.24rem;
  color: #333;
  word-wrap:break-word;
  word-break:break-all;
  text-align: left;
}
.phoneRight-left-img{
  width: 0.48rem;
  height: auto;
  margin-left: 4px;
}
.phoneRight-left-font{
  font-size: 0.24rem;
  color: #333;
  margin-left: 6px;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
}
.phoneRight-right-bnt{
  width: 1.6rem;
  height: 0.68rem;
  font-size: 0.18rem;
  line-height: 0.68rem;
  color: #fff;
  border-radius: 0.68rem;
  background: #603773;
  margin-right: 0.26rem;
}

/**  web  案例  **/
.carbon-leg{
  padding: 0.32rem 0.5rem;
  height: auto;
  background: #f4f4f4;
}
.carbon-leg-center{
  width: 100%;
  height: auto;
  position: relative;
}
.leg-center-left{
  width: auto;
  height: auto;
}
.center-left-middle{
  width: 54%;
  padding: 0.25rem 0.375rem;
  padding-right: 0.75rem;
  height: auto;
  background: #fff;
  min-height: 3.4rem;
}
.left-middle-title{
  font-size: 0.1125rem;
  color: #333;
  line-height: 1.4;
  font-weight: 500;
  text-align: left;
  width: 50%;
}
.left-middle-font{
  font-size: 0.0875rem;
  color: #333;
  line-height: 1.8;
  text-align: left;
  margin-top: 0.25rem;
}
.left-middle-bottom{
  width: 100%;
  height: auto;
  margin-top: 0.225rem;
}
.leg-center-right{
  width: 50%;
  height: 3.0875rem;
  position: absolute;
  top: 0;
  right: 0;
}

/**  phone  案例  **/
.phone-carbon-leg{
  padding: 0.48rem 0.5rem;
  height: auto;
  background: #f4f4f4;
}
.phoneCarbon-leg-center{
  margin-top: 0.48rem;
  width: 100%;
  height: auto;
}
.leg-center-img{
  width: 100%;
  height: auto;
  border-radius: 6px 6px 0 0;
}
.leg-center-bottom{
  padding: 0.42rem 0.24rem;
  height: auto;
  background: #fff;
  border-radius: 0 0 6px 6px;
}
.center-bottom-title{
  font-size: 0.32rem;
  color: #333;
  font-weight: 500;
  margin-bottom: 0.42rem;
}
.center-bottom-font{
  font-size: 0.24rem;
  color: #333;
  line-height: 1.4;
  text-align: left;
  margin-bottom: 0.28rem;
}

/**  web  活动  **/
.index-foot-list{
  width: 100%;
  height: 0.75rem;
  box-shadow: 2px 2px 4px #c9c9c9;
  margin-bottom: 0.225rem;
  cursor: pointer;
}
.foot-list-left{
  width: auto;
  height: 0.75rem;
}
.list-left-tips{
  width: 0.1875rem;
  height: 0.75rem;
  background: #603773;
  font-size: 0.15rem;
  color: #fff;
  text-align: center;
  writing-mode:vertical-rl;
  letter-spacing: 4px;
}
.list-left-radiu{
  width: 0.625rem;
  height: 0.625rem;
  border-radius: 50%;
  margin-left: 0.125rem;
  border: 2px solid #603773;
}
.left-radiu-tips{
  font-size: 0.15rem;
  color: #603773;
  font-weight: 'wwf';
  line-height: 1.4;
}
.left-radiu-center{
  font-size: 0.225rem;
  color: #603773;
  font-family: 'wwf';
  line-height: 1.4;
}
.list-left-right{
  margin-left: 0.2625rem;
  height: 0.75rem;
}
.left-right-title{
  font-size: 0.1875rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1;
  margin-top: 0.1625rem;
}
.left-right-bottom{
  margin-top: 0.1125rem;
}
.bottom-list-img{
  width: 0.1875rem;
  height: auto;
  margin-right: 0.0625rem;
}
.right-bottom-list{
  margin-right: 0.25rem;
}
.bottom-list-font{
  font-size: 0.1125rem;
  color: #000;
  line-height: 0.1875rem;
}
.foot-list-right{
  color: #603773;
  font-size: 0.1125rem;
  margin-right: 0.175rem;
  cursor: pointer;
  opacity: 0.8;
}

/**  phone  活动  **/
.phone-foot-list{
  width: 100%;
  height: 2.4rem;
  box-shadow: 2px 2px 4px #c9c9c9;
  margin-bottom: 0.533rem;
}
.phone-list-left{
  width: auto;
  height: 2.4rem;
}
.phone-left-tips{
  width: 0.56rem;
  height: 2.4rem;
  background: #603773;
  font-size: 0.4rem;
  color: #fff;
  text-align: center;
  writing-mode:vertical-rl;
  letter-spacing: 4px;
}
.phone-left-radiu{
  width: 1.333rem;
  min-width: 1.333rem;
  height: 1.333rem;
  border-radius: 50%;
  margin-left: 0.347rem;
  border: 2px solid #603773;
}
.phone-radiu-tips{
  font-size: 0.32rem;
  color: #603773;
  font-weight: 'wwf';
  line-height: 1.4;
}
.phone-radiu-center{
  font-size: 0.48rem;
  color: #603773;
  font-family: 'wwf';
  line-height: 1.4;
}
.phone-left-right{
  margin-left: 0.373rem;
  height: 2.4rem;
}
.phone-right-title{
  font-size: 0.4rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1.4;
  margin-top: 0.2667rem;
  text-align: left;
}
.phone-right-bottom{
  margin-top: 0.32rem;
}
.phone-list-img{
  width: 0.426rem;
  height: auto;
  margin-right: 0.133rem;
}
.phone-bottom-list{
  margin-right: 0.8rem;
}
.phone-list-font{
  font-size: 0.32rem;
  color: #000;
  line-height: 0.426rem;
}

  /**  pc端 列表  **/
  .dynamic-center-list{
    width: 100%;
    height: auto;
    padding: 0.375rem 0.5rem 0.537rem;
    background-color: #fff;
  }
  .dynamic-center-list:nth-child(2n){
    background-color: #f7f7f8;
  }
  .center-list-top{
    width: 100%;
    height: auto;
  }
  .list-top-left{
    font-size: 0.281rem;
    font-family: 'wwf';
  }
  .top-left-label{
    width: 0.063rem;
    height: 0.25rem;
    margin-right: 0.15rem;
  }
  .top-right-btn{
    width: 0.94rem;
    height: 0.312rem;
    cursor: pointer;
  }
  .right-btn-font{
    font-size: 0.125rem;
    font-family: 'wwf';
    color: #fff;
  }
  .right-btn-icon{
    width: 0.125rem;
    height: auto;
    margin-left: 0.05rem;
  }
  .center-list-center{
    margin-top: 0.262rem;
    width: 100%;
    height: auto;
  }
  .list-center-li{
    width: 49.5%;
    height: auto;
    box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
    margin-bottom: 0.131rem;
    cursor: pointer;
  }
  .center-li-left{
    width: auto;
    height: auto;
    position: relative;
  }
  .li-left-btns{
    position: absolute;
    bottom: 0.125rem;
    left: 0.03rem;
    right: 0.03rem;
  }
  .center-li-img{
    width: 1.875rem;
    height: 1.25rem;
    object-fit: cover;
  }
  .left-btns-btn{
    padding: 0.0625rem 0.0875rem;
    font-size: 0.0875rem;
    color: #fff;
    line-height: 1;
    margin: 0 0.03rem;
  }
  .center-li-right{
    flex: 2;
    height: 1.25rem;
    padding: 0.1875rem 0.1875rem 0.1625rem 0.225rem;
  }
  .li-right-title{
    font-size: 0.125rem;
    line-height: 1.5;
    font-family: 'wwf';
    text-align: left;
  }
  .li-right-bottom{
    width: 100%;
  }
  .right-bottom-time{
    font-size: 0.1125rem;
    color: #999999;
  }
  .right-bottom-tips{
    font-size: 0.1125rem;
  }

  /**  WEB端 列表  **/
  .phone-center-list{
    padding: 0.5rem;
    height: auto;
  }
  .center-list-top{
    font-size: 0.42rem;
    color: #333333;
    font-weight: 600;
    text-align: center;
    margin-bottom: 0.25rem;
  }
  .phoneCarbon-leg-center {
    margin-top: 0.48rem;
    width: 100%;
    height: auto;
    box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    margin-bottom: 0.45rem;
  }
  .leg-center-top{
    width: 100%;
    height: auto;
    position: relative;
  }
  .leg-center-img {
    width: 100%;
    height: auto;
    border-radius: 6px 6px 0 0;
  }
  .info-list-layer{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
  }
  .list-layer-li{
    margin-bottom: 0.125rem;
    padding: 6px 10px;
    font-size: 0.25rem;
    color: #fff;
    background: #32a5cf;
    margin-right: 0.15rem;
    display: inline-block;
    line-height: 1;
  }
  .list-layer-li:nth-child(1){
    margin-left: 0.25rem;
  }
  .leg-center-bottom {
    padding: 0.42rem 0.24rem;
    height: auto;
    background: #fff;
    border-radius: 0 0 6px 6px;
  }
  .center-bottom-title {
    font-size: 0.48rem;
    color: #000;
    font-family: 'wwf';
    line-height: 1.4;
    margin-bottom: 0.32rem;
    text-align: left;
  }
  .center-bottom-bottom{
    padding-top: 0.28rem;
    width: 100%;
    height: auto;
  }
  .bottom-bottom-left,.bottom-bottom-right{
    font-size: 0.32rem;
    color: #999;
  }
  .center-list-bottom{
    padding-top: 0.32rem;
    margin-bottom: 0.32rem;
    height: auto;
    width: 100%;
  }
  .list-bottom-btn{
    width: 4rem;
    height: 1.067rem;
    font-size: .4rem;
    color: #fff;
    margin: 0 auto .5rem;
  }
  .bg1{
    background-color: #a08ac0;
  }
</style>